import ssa_114_1 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_1.pdf";
import ssa_114_2 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_2.pdf";
import ssa_114_3 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_3.pdf";
import ssa_114_4 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_4.pdf";
import ssa_114_5 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_5.pdf";
import ssa_114_6 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_6.pdf";
import ssa_114_7 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_7.pdf";
import ssa_114_8 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_8.pdf";
import ssa_114_9 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_9.pdf";
import ssa_114_10 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_10.pdf";
import ssa_114_11 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_11.pdf";
import ssa_114_12 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_12.pdf";
import ssa_114_13 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_13.pdf";
import ssa_114_14 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_14.pdf";
import ssa_114_15 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_15.pdf";
import ssa_114_16 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_16.pdf";
import ssa_114_17 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_17.pdf";
import ssa_114_18 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_18.pdf";
import ssa_114_19 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_19.pdf";
import ssa_114_20 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_20.pdf";
// import ssa_114_21 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_21.pdf";
// import ssa_114_22 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_22.pdf";
// import ssa_114_23 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_23.pdf";
// import ssa_114_24 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_24.pdf";
// import ssa_114_25 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_25.pdf";
// import ssa_114_26 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_26.pdf";
// import ssa_114_27 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_27.pdf";
// import ssa_114_28 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_28.pdf";
// import ssa_114_29 from "@/assets/studentAwardsRouter/studentAwardsFile/114/ssa_114_29.pdf";
var awardsPath_114 = [
  ssa_114_1,
  ssa_114_2,
  ssa_114_3,
  ssa_114_4,
  ssa_114_5,
  ssa_114_6,
  ssa_114_7,
  ssa_114_8,
  ssa_114_9,
  ssa_114_10,
  ssa_114_11,
  ssa_114_12,
  ssa_114_13,
  ssa_114_14,
  ssa_114_15,
  ssa_114_16,
  ssa_114_17,
  ssa_114_18,
  ssa_114_19,
  ssa_114_20,
  // ssa_114_21,
  // ssa_114_22,
  // ssa_114_23,
  // ssa_114_24,
  // ssa_114_25,
  // ssa_114_26,
//   ssa_114_27,
//   ssa_114_28,
//   ssa_114_29,
];
export { awardsPath_114 };
